var _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentImageSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.05,
    height: 18.7,
    viewBox: "0 0 22.05 18.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "document-image-search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document-image-search"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,20.8a3.21,3.21,0,0,1-3.5-3.5V11.2A3.21,3.21,0,0,1,4.9,7.7h3a.1.1,0,0,1,.1.1c.2.3.3.2.3.3s-.4.2-.5.6v.4a5.38,5.38,0,0,0,1.8,2.7,4.23,4.23,0,0,0,3.6.1v5.5a3.21,3.21,0,0,1-3.5,3.5ZM2.3,11.3v6.1A2.28,2.28,0,0,0,4.9,20H9.7a2.28,2.28,0,0,0,2.6-2.6V11.8a3.25,3.25,0,0,1-2,0A3.39,3.39,0,0,1,8.4,8.7c-1.1,0-2.3,0-3.4.1C3.1,8.7,2.3,9.6,2.3,11.3Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,13.1H3.8a.27.27,0,0,1-.3-.3v-.2a.27.27,0,0,1,.3-.3H6.6a.27.27,0,0,1,.3.3v.2A.32.32,0,0,1,6.6,13.1Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,14.9H3.8a.27.27,0,0,1-.3-.3v-.2a.27.27,0,0,1,.3-.3H11a.27.27,0,0,1,.3.3v.2A.27.27,0,0,1,11,14.9Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,16.8H3.9a.27.27,0,0,1-.3-.3v-.2a.27.27,0,0,1,.3-.3H7.8a.27.27,0,0,1,.3.3v.2A.27.27,0,0,1,7.8,16.8Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.9,12.9a4.2,4.2,0,1,1,4.2,4.2A4.23,4.23,0,0,1,13.9,12.9Zm.7,0a3.6,3.6,0,1,0,3.6-3.6A3.59,3.59,0,0,0,14.6,12.9Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2,17.4l-.8-.8a.28.28,0,0,1,.4-.4l.8.8a.3.3,0,0,1,0,.4c-.1.1-.1.1-.2.1A.35.35,0,0,1,22.2,17.4Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_108",
    "data-name": "Capa 108"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.2,12.3c-2.4,0-3.4-1-3.4-3.4V6.2c0-2.4,1-3.4,3.4-3.4h2.7c2.4,0,3.4,1,3.4,3.4V8.9c-1-.3-3.5,3.3-3.4,3.4ZM8.4,6.2V8.9c0,2,.7,2.8,2.8,2.8h2.7a12.4,12.4,0,0,0,2.8-2.8V6.2c0-2-.7-2.8-2.8-2.8H11.2C9.1,3.4,8.4,4.1,8.4,6.2Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,5.7a1.2,1.2,0,0,1,2.4,0,1.2,1.2,0,0,1-2.4,0Zm.6,0a.58.58,0,0,0,.6.6.53.53,0,0,0,.6-.6.53.53,0,0,0-.6-.6A.58.58,0,0,0,10.6,5.7Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.1,10.8c-.1-.2-.1-.4.1-.5h0l2.2-1.5a1.36,1.36,0,0,1,1.6.1l.1.1a.61.61,0,0,0,.8,0l1.8-1.6a1.35,1.35,0,0,1,1.7,0l.7.6a.35.35,0,0,1-.5.5L16,8a.61.61,0,0,0-.8,0L13.4,9.6a1.35,1.35,0,0,1-1.7,0l-.1-.1a.6.6,0,0,0-.8,0L8.6,11c-.1,0-.1.1-.2.1C8.3,10.9,8.2,10.9,8.1,10.8Z",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.8,10.2",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,10",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,9.5",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4,
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.1,8.3",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,8.2",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    fillRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.1 -2.5)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentImageSearch);
export default __webpack_public_path__ + "static/media/document-image-search.7c77f742fbf68be3db140d9117258867.svg";
export { ForwardRef as ReactComponent };